import { Timer } from 'three';
import { defineComponent, inject, onUnmounted, provide } from 'vue';

import { useRaf, useRenderer } from '@resn/gozer-vue';

export const TimerKey = Symbol('Timer');

export const useTimer = () => {
    const provider = inject(TimerKey);

    if (!provider) {
        throw new Error('Timer provider not found');
    }

    return provider;
};

export const TimerProvider = defineComponent({
    props: {},

    async setup() {
        const timer = new Timer();

        const provider = {
            timer,
        };

        useRaf(({ timestamp }) => {
            timer.update(timestamp);
        });

        provide(TimerKey, provider);
    },

    render() {
        if (this.$slots.default) {
            return this.$slots.default();
        }

        return null;
    },
});
